import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Estado del modal fullscreen del formulario de cotización (wizard).
 * Permite abrir el wizard como overlay desde la lista (patrón modal) sin navegar a otra pantalla.
 * Las rutas /cotizaciones/crear y /cotizaciones/editar/:id siguen funcionando para deep-linking:
 * en ese caso el componente se muestra en modo "ruta" y al cerrar navega de vuelta a /cotizaciones.
 */
export interface QuoteFormModalState {
  open: boolean;
  /** id de la cotización a editar; undefined = crear nueva. */
  quoteId?: number;
  /** abrir el modal de "Enviar al cliente" tras cargar (equivale a ?enviar=1 de la ruta). */
  sendEmail?: boolean;
  /**
   * id del negocio a PRESELECCIONAR al crear una cotización nueva (abrir desde el detalle/kanban/lista
   * de negocios). Solo aplica en alta (sin quoteId): fija el negocio en el paso 1 y precarga su
   * contacto primario. Se ignora al editar.
   */
  dealId?: number;
}

@Injectable({ providedIn: 'root' })
export class QuoteFormModalService {
  private readonly stateSubject = new BehaviorSubject<QuoteFormModalState>({ open: false });
  readonly state$ = this.stateSubject.asObservable();

  /** Emite cuando el wizard guardó (crear o actualizar): la lista refresca al recibirlo. */
  private readonly savedSubject = new Subject<void>();
  readonly saved$ = this.savedSubject.asObservable();

  open(opts?: { quoteId?: number; sendEmail?: boolean; dealId?: number }): void {
    this.stateSubject.next({
      open: true,
      quoteId: opts?.quoteId,
      sendEmail: opts?.sendEmail,
      dealId: opts?.dealId
    });
  }

  close(): void {
    this.stateSubject.next({ open: false });
  }

  notifySaved(): void {
    this.savedSubject.next();
  }
}
